import { IvsEventType } from '../constants/ivs';

export { getIvsClientId } from '@shopee-user/shared-customization-logic/src/ivs/config';

export const getLoginIvsEventType = (): number => IvsEventType.Login;

export const getOneCredentialLoginIvsEventType = (): number =>
  IvsEventType.OneCredentialLogin;
